const detailTableData = [
	{
		title: null,
		description: '28 cm size',
		ingredients: 'Ingredients',
	},
	{
		title: '24',
		description: '28 cm size',
		ingredients: 'Egg',
	},
	{
		title: '728',
		description: 'Energy',
		ingredients: 'Milk Protein',
	},
	{
		title: '1054',
		description: 'Calo',
		ingredients: 'Sesame',
	},
	{
		title: '68',
		description: 'Fat',
		ingredients: 'Lactose',
	},
	{
		title: '25',
		description: 'Gluxit',
		ingredients: 'Gluten',
	},
	{
		title: '548',
		description: 'Protein',
		ingredients: 'Mustard',
	},
];

export { detailTableData };
